<div class="theme-wrapper" [ngClass]="themeService.theme">
  <ng-progress [spinner]="false" ngProgressHttp></ng-progress>

  @if (sessionService.tokenValid() && sessionService.schemeId && sessionService.isSessionReady) {
    <div class="app-shell d-flex flex-column vh-100" [class.app-shell--chrome-hidden]="appChrome.hidden()">
      <div class="app-notices d-grid gap-2">
        <!-- load status cta after scheme status is found in storage -->
        @if (sessionService.schemeStatus) {
          <loyale-status-cta></loyale-status-cta>
        }
        <!-- load setup cta after scheme setup is found in storage -->
        @if (sessionService.schemeSetup) {
          <loyale-setup-cta></loyale-setup-cta>
        }
        <!-- load health cta after scheme health is found in storage -->
        @if (sessionService.schemeHealth) {
          <!-- only show health cta if shceme is not a demo -->
          @if (sessionService.schemeStatus != 5) {
            <loyale-health-cta></loyale-health-cta>
          }
        }
      </div>
      <mat-sidenav-container #navigationContainer [class.navigation-overlay-mode]="navigationOverlayMode">
        <mat-sidenav class="app-sidenav" [class.app-sidenav--overlay]="navigationOverlayMode" #appSidenav
          [mode]="sidenavMode" [opened]="sidenavOpen && !appChrome.hidden()"
          [fixedInViewport]="mobileMode"
          [disableClose]="navigationOverlayMode ? false : true">
          <loyale-sidenav (openChangelogRequested)="toggleReleaseNotesSidenav()"
            (collapsedChange)="onNavigationWidthChange()"></loyale-sidenav>
        </mat-sidenav>
        <mat-sidenav position="end" mode="over" [style.width]="mobileMode ? '100vw' : 'min(718px, 100vw)'"
          [opened]="releaseNotesSidenavOpen" (closedStart)="closeReleaseNotesSidenav()">
          @if (releaseNotesSidenavOpen) {
            <loyale-release-notes-sidenav
            (closeRequested)="closeReleaseNotesSidenav()"></loyale-release-notes-sidenav>
          }
        </mat-sidenav>
        <mat-sidenav-content class="app-content">
          @if (navigationOverlayMode && !appChrome.hidden()) {
            <div class="toggle-wrapper">
              <button mat-mini-fab color="primary" aria-label="Open navigation" (click)="sidenav.toggle()">
                <mat-icon>apps</mat-icon>
              </button>
            </div>
          }
          <router-outlet></router-outlet>
          <div class="app-content-spacer" aria-hidden="true"></div>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
  } @else {
    <div>
      <div class="tags-background"></div>
      <router-outlet></router-outlet>
      <div class="build-info position-fixed" title="Built {{ env.buildInfo.builtAt }}">
        <small class="build-bubble auth" (click)="onSuperClick()">
          {{ env.buildInfo.version }}
          @if (!env.production) {
            <span> · {{ env.name }} · Commit {{ env.buildInfo.commit }} · Build {{ env.buildInfo.number }}</span>
          }
        </small>
      </div>
    </div>
  }


  <tour-step-template>
    <ng-template let-step="step">
      <mat-card (click)="$event.stopPropagation()" class="tour-dialog" [style.width]="step.stepDimensions?.width"
        [style.min-width]="step.stepDimensions?.minWidth" [style.max-width]="step.stepDimensions?.maxWidth"
        [style.height]="step.stepDimensions?.height" [style.min-height]="step.stepDimensions?.minHeight"
        [style.max-height]="step.stepDimensions?.maxHeight">
        <mat-card-header class="w-100 d-flex align-items-center justify-content-between">

          <mat-card-title class="mb-0">
            <div>{{step.title}}</div>

          </mat-card-title>
          <button mat-icon-button (click)="tourService.end()">
            <mat-icon>close</mat-icon>
          </button>

        </mat-card-header>

        <mat-card-content [innerHTML]="step.content">

        </mat-card-content>

        <div class="d-flex">
          <button mat-button [disabled]="!tourService.hasPrev(step)" (click)="tourService.prev()">
            <mat-icon>chevron_left</mat-icon>
            {{step.prevBtnTitle}}
          </button>

          <div class="flex-fill"></div>

          @if (tourService.hasNext(step) && !step.nextOnAnchorClick) {
            <button (click)="tourService.next()" mat-button>
              {{step.nextBtnTitle}}
              <mat-icon iconPositionEnd>chevron_right</mat-icon>
            </button>
          }
          @if (!tourService.hasNext(step)) {
            <button mat-button (click)="tourService.end()">
              {{step.endBtnTitle}}
            </button>
          }
        </div>
      </mat-card>

    </ng-template>
  </tour-step-template>
</div>
